/* cy-choose.js — the "Help me choose" panel on the Cybeart PDPs.
   Markup: snippets/cy-choose-help.liquid + cy-choose-table.liquid.

   - Opens on CLICK (owner: most traffic is mobile, hover does not work there).
     A native <dialog>: Esc, focus trapping and the top layer come free.
   - Tabs (keyboards: "Compare models" / "Wireless vs Lite") and the model
     switcher inside the Lite tab.
   - Mobile shows two columns; the two selects above a table choose which.
   - Select closes the panel, opens that model's row in the picker, scrolls to
     it and flashes the matching cards. The shopper stays on the page.

   The scroll lock is our own class on <html>, never the inline overflow the
   theme's drawers write — two owners on one global got out of step before
   (see the bundle drawer history in cy-pdp.js). */
(function () {
  'use strict';
  if (window.__cyChoose) return;
  window.__cyChoose = true;

  var LOCK = 'cyh-locked';

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function setCols(cmp) {
    var sels = cmp.querySelectorAll('[data-cmp-sel]');
    if (sels.length < 2) return;
    var a = sels[0].value, b = sels[1].value;
    /* the same model in both slots would show one column twice-hidden; keep
       them distinct by nudging the one that was not just changed */
    each(cmp.querySelectorAll('[data-col]'), function (cell) {
      var c = cell.getAttribute('data-col');
      cell.classList.toggle('is-off', c !== a && c !== b);
      cell.style.order = c === a ? '1' : (c === b ? '2' : '3');
    });
  }

  function initDialog(dlg) {
    var opener = document.querySelector('[aria-controls="' + dlg.id + '"]');
    if (!opener || !dlg.showModal) return;

    function close() {
      if (dlg.open) dlg.close();
    }
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove(LOCK);
    });
    /* a MutationObserver backs the class up: if anything removes `open`
       without a close event, the page must not stay locked */
    new MutationObserver(function () {
      if (!dlg.open) document.documentElement.classList.remove(LOCK);
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });

    opener.addEventListener('click', function () {
      if (dlg.open) return;
      dlg.showModal();
      document.documentElement.classList.add(LOCK);
    });
    each(dlg.querySelectorAll('[data-help-close]'), function (b) { b.addEventListener('click', close); });
    /* a click on the backdrop lands on the dialog element itself */
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });

    /* tabs — the tablist pattern (Phase 3, HIG keyboard): one tab stop, arrows / Home / End move and select */
    var tabs = [].slice.call(dlg.querySelectorAll('[data-help-tab]'));
    function showTab(t, focus) {
      var name = t.getAttribute('data-help-tab');
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
      });
      each(dlg.querySelectorAll('[data-help-panel]'), function (p) {
        p.hidden = p.getAttribute('data-help-panel') !== name;
      });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { showTab(t, false); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : e.key === 'Home' ? -i : e.key === 'End' ? (tabs.length - 1 - i) : 0;
        if (!d) return;
        e.preventDefault();
        showTab(tabs[(i + d + tabs.length) % tabs.length], true);
      });
      t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
    });

    /* model switcher (Wireless vs Lite) */
    each(dlg.querySelectorAll('[data-help-model]'), function (m) {
      m.addEventListener('click', function () {
        var key = m.getAttribute('data-help-model');
        each(dlg.querySelectorAll('[data-help-model]'), function (x) {
          x.setAttribute('aria-pressed', x === m ? 'true' : 'false');
        });
        each(dlg.querySelectorAll('[data-help-modelpane]'), function (p) {
          p.hidden = p.getAttribute('data-help-modelpane') !== key;
        });
      });
    });

    /* mobile column selects */
    each(dlg.querySelectorAll('[data-cmp]'), function (cmp) {
      var sels = cmp.querySelectorAll('[data-cmp-sel]');
      each(sels, function (s, i) {
        s.addEventListener('change', function () {
          var other = sels[1 - i];
          if (other && other.value === s.value) {
            /* never the same model twice: move the other one along */
            var opts = other.options;
            for (var k = 0; k < opts.length; k++) {
              if (opts[k].value !== s.value) { other.value = opts[k].value; break; }
            }
          }
          setCols(cmp);
        });
      });
      setCols(cmp);
    });

    /* Select -> close, open the picker row, flash its cards */
    each(dlg.querySelectorAll('[data-help-select]'), function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-help-select');
        var prod = btn.getAttribute('data-help-prod');
        close();
        var root = dlg.closest('[data-cyp]') || document;
        var group = root.querySelector('[data-group-key="' + key + '"]');
        if (!group) return;
        if (!group.open) {
          var sum = group.querySelector('summary');
          if (sum) sum.click(); else group.open = true;
        }
        /* after the accordion has had a frame to start opening */
        setTimeout(function () {
          document.documentElement.style.scrollBehavior = '';
          group.scrollIntoView({ behavior: 'smooth', block: 'start' });
          group.classList.remove('is-flash');
          void group.offsetWidth;
          group.classList.add('is-flash');
          var cards = prod ? group.querySelectorAll('[data-prod="' + prod + '"]') : [];
          each(cards, function (c) {
            c.classList.remove('is-flash');
            void c.offsetWidth;
            c.classList.add('is-flash');
          });
          setTimeout(function () {
            group.classList.remove('is-flash');
            each(cards, function (c) { c.classList.remove('is-flash'); });
          }, 2200);
        }, 60);
      });
    });
  }

  function init() { each(document.querySelectorAll('[data-help]'), initDialog); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
